import {storeAccessToken, storeIdToken} from "./service/authActions";
import React from "react";
import {Provider} from 'react-redux';
import ReactDOM from "react-dom";
import {createBrowserHistory} from "history";
import {Route, Router, Switch} from "react-router-dom";
import "assets/css/material-dashboard-react.css?v=1.2.0";
import "assets/css/global.css";

import indexRoutes from "routes/index.jsx";
import configureStore from "./store";
import LoginPage from "./layouts/LoginPage";
import OktaSignIn from '@okta/okta-signin-widget';
import getRedirectUrl, {getIssuer, getOktaBaseUrl} from "service/redirectUrl";


export const store = configureStore()

let redirectUrl = getRedirectUrl(window.location.origin);
let oktaBaseUrl = getOktaBaseUrl(window.location.origin);
let issuer = getIssuer(window.location.origin);

export let oktaSignIn = new OktaSignIn({
    baseUrl: oktaBaseUrl,
    clientId: 'nike.gtm.nts-monitoring',
    redirectUri: redirectUrl,
    authParams: {
        issuer: issuer,
        responseType: ['id_token','token'],
        display: 'page'
    }
});

const hist = createBrowserHistory();
if (!window.location.hash.includes("token")) {
    const hasToken =
        oktaSignIn &&
        oktaSignIn.tokenManager &&
        oktaSignIn.tokenManager.get('access_token') &&
        Object.keys(oktaSignIn.tokenManager.get('access_token')).length > 0 &&
        oktaSignIn.tokenManager.get('access_token').accessToken;
    if (!(hasToken) && (window.location.pathname != '/' && window.location.pathname != '/login')) {
        window.location = '/';
    }
} else {
    try {
        // start - we do not need to parse token as following and store it in redux, since we use oktaSignIn.tokenManager
        let idTokenKey = window.location.hash.substr(1).split('&')[0].split('=')[0];
        let idTokenValue = window.location.hash.substr(1).split('&')[0].split('=')[1];
        let accessTokenKey = window.location.hash.substr(1).split('&')[1].split('=')[0];
        let accessTokenValue = window.location.hash.substr(1).split('&')[1].split('=')[1];

        store.dispatch(storeIdToken(idTokenValue));
        store.dispatch(storeAccessToken(accessTokenValue));
        // end

        oktaSignIn.token.parseTokensFromUrl(
            function success(res) {
                // Add the token to tokenManager to automatically renew the token when needed
                oktaSignIn.tokenManager.add('id_token', res[0]);
                oktaSignIn.tokenManager.add('access_token', res[1]);
                hist.push("/dashboard?token=1");
            },
            function error(err) {
                console.log('handle error', err);
            }
        );


    } catch (e) {
        console.log("Error in parsing ");
        window.location = "/";
    }
}

ReactDOM.render((
        <Provider store={store}>
            <Router history={hist}>

                <Switch>
                    {indexRoutes.map((prop, key) => {
                        return <Route path={prop.path} component={prop.component} key={key}/>;
                    })}

                    <index Routes component={LoginPage}/>

                </Switch>

            </Router>
        </Provider>
    ),
    document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js